var React = require('react');

function TrianglesRightMessageConversation (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M128.129 134.449L180.965 3.34444L265.665 209.224L128.129 134.449Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M5.69067 139.686L181.171 3.33539L128.347 134.246L5.69067 139.686Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M5.69141 139.686L128.261 134.25L265.663 209.224L5.69141 139.686Z","fill":"#5915C7","key":2})]);
}

TrianglesRightMessageConversation.defaultProps = {"width":"241","height":"221","viewBox":"0 0 241 221","fill":"none"};

module.exports = TrianglesRightMessageConversation;

TrianglesRightMessageConversation.default = TrianglesRightMessageConversation;
